document
  .querySelectorAll('[data-exandable-self-pay-cards-collapsible]')
  .forEach((controller) => {
    const activator = controller.querySelector(
      '[data-data-exandable-self-pay-cards-show-more]',
    );
    activator.addEventListener('click', () => {
      controller.classList.toggle('closed');
      if (controller.classList.contains('closed')) {
        activator.innerHTML = 'Show more';
      } else {
        activator.innerHTML = 'Show less';
      }
    });
  });
